import { render, staticRenderFns } from "./customer-picker.vue?vue&type=template&id=0adc2ffb&scoped=true"
import script from "./customer-picker.vue?vue&type=script&lang=js"
export * from "./customer-picker.vue?vue&type=script&lang=js"
import style0 from "./customer-picker.vue?vue&type=style&index=0&id=0adc2ffb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adc2ffb",
  null
  
)

export default component.exports